"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const _mapKeys = /*#__PURE__*/ _interop_require_default(require("lodash/mapKeys"));
const _Debug = /*#__PURE__*/ _interop_require_default(require("../../../util/Debug"));
const _Result = /*#__PURE__*/ _interop_require_default(require("../../../util/Result"));
const _MysqlClient = /*#__PURE__*/ _interop_require_default(require("./MysqlClient"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const log = new _Debug.default('TidbClient');
let Tidb = class Tidb extends _MysqlClient.default {
    /**
   *
   * @param {Object} - args - Input arguments
   * @param {Object} - args.tn -
   * @returns {Object[]} - indexes
   * @property {String} - indexes[].cstn -
   * @property {String} - indexes[].cn -
   * @property {String} - indexes[].op -
   * @property {String} - indexes[].puc -
   * @property {String} - indexes[].cst -
   */ async constraintList(args = {}) {
        const func = this.constraintList.name;
        const result = new _Result.default();
        log.api(`${func}:args:`, args);
        try {
            const response = await this.sqlClient.raw(`select *, TABLE_NAME as tn from INFORMATION_SCHEMA.KEY_COLUMN_USAGE where CONSTRAINT_SCHEMA=? and TABLE_NAME=?`, [
                this.connectionConfig.connection.database,
                args.tn
            ]);
            if (response.length === 2) {
                const indexes = [];
                for(let i = 0; i < response[0].length; ++i){
                    let index = response[0][i];
                    index = (0, _mapKeys.default)(index, function(_v, k) {
                        return k.toLowerCase();
                    });
                    indexes.push(index);
                }
                result.data.list = indexes;
            } else {
                log.debug('Unknown response for databaseList:', result.data.list.length);
                result.data.list = [];
            }
        } catch (e) {
            log.ppe(e, func);
            throw e;
        }
        log.api(`${func}: result`, result);
        return result;
    }
};
const _default = Tidb;
